<template>
  <v-row class="py-6" align="center" justify="center">
    <v-col class="text-center" cols="12">
      <v-icon class="my-6" color="primary" x-large>mdi-check-circle</v-icon>
      <span class="d-block subtitle-1 text--secondary font-weight-medium">Suscripción exitosa a</span>
      <span class="d-block subtitle-1" v-for="(l, i) in instance.subscription.lines" :key="i">{{l.plan.product.name}}</span>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data: () => ({
    instance: {
      subscription: {
        lines: []
      }
    }
  }),
  created () {
    this.$store.dispatch('apps/RETRIEVE', {
      resource: 'publishable/signup_forms/signups',
      id: this.$route.params.id,
      setDetail: false
    })
    .then((response) => {
      this.instance = Object.assign({}, response.data)
    })
  }
}
</script>
